import { CorporateHomePageEntity } from '@/modules/homepage/domain/entities/CorporateHomePageEntity';
import { corporateHomepagesRoute } from '@/modules/homepage/domain/routes/homepageRoutes';
import { CorporateHomepage } from '@/types/homepage';
import { getData } from '@/utils/corpo/request/getData';

export const getHomepages = async () => {
  const response = await getData<{ data: CorporateHomepage[] }>(corporateHomepagesRoute);

  return (response?.data || []).map((d) => new CorporateHomePageEntity(d).toHomepage());
};
